import React from 'react';
import PropTypes from 'prop-types';

import ResponsiveDataList from '../Table/ResponsiveDataList';
import PagedView from './PagedView';

/** renders data in list format within the PagedView component
 *  ALL PROPS ARE PASSED TO PAGED_VIEW -> PAGE and RESPONSIVE_DATA_LIST
 *  (see PagedView, Page and ResponsiveDataList documentation) */
export default class ListView extends React.Component {
  static propTypes = {
    /** overrides the default behavior for activePage */
    activePage: PropTypes.number,
    /** define how the table rows are rendered
     *  (passed to ResponsiveDataList -> Table -> BootstrapTable component)
     *  documentation of additional BootstrapTable column props can be found at
     *  https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/column-props.html */
    fields: PropTypes.arrayOf(PropTypes.shape({
      /** if set to true, then the list will be sorted by this column by default */
      defaultSort: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string
      ])
    })).isRequired,
    /** this method will be called to fetch data for the table
     * called with ({ value: sortColumn, direction: sortDirection }, activePage) */
    loadAction: PropTypes.func,
    /** callback(activePage) when page is changed */
    onPageChange: PropTypes.func,
    /** callback(sortColumn, sortDirection) when page is changed */
    onSortChange: PropTypes.func,
    /** any table options are passed to ResponsiveDataList -> Table component */
    options: PropTypes.object
  }

  static defaultProps = {
    closeTimeoutModal: () => { return false },
    downloadAction: () => { return false },
    expandComponent: null,
    expandableRow: row => { return false },
    fullPage: true,
    hasPagination: true,
    keyField: 'id',
    onPageChange: () => {},
    onSortChange: () => {},
    trClassName: row => ''
  }

  constructor(props) {
    super(props);

    const { activePage, fields } = props;

    this.state = {
      activePage
    };

    const defaultSortField = fields.find((field) => field.defaultSort);

    if (defaultSortField) {
      this.state.sort = {
        value: defaultSortField.name,
        direction: defaultSortField.defaultSort === true ?
          'asc' : defaultSortField.defaultSort
      };
    }
  }

  componentWillReceiveProps(newProps) {
    const { activePage } = newProps;

    if(!!activePage && activePage !== this.state.activePage) {
      this.setState({ activePage });
    }
  }

  onPageChange = (activePage) => {
    this.setState({ activePage }, () => {
      this.props.onPageChange(activePage);
    });
  }

  onSortChange = (sortName, sortOrder) => {
    const { onSortChange } = this.props;
    onSortChange(sortName, sortOrder);
    this.onPageChange(1);
    this.setState({
      activePage: 1,
      sort: {
        value: sortName,
        direction: sortOrder
      }
    }, this.loadData);
  }

  loadData = () => {
    this.props.loadAction(this.state.sort, this.state.activePage);
  }

  /** calling this method to triggers a highlight animation on the row whose
   *  keyField matches the provided value */
  highlightRow = value => {
    if (this.dataList) {
      this.dataList.highlightRow(value);
    }
  }

  get tableOptions() {
    const { options } = this.props;
    const { sort } = this.state;

    const tableOptions = Object.assign({
      bordered: false,
      hover: true,
      striped: false,
      onSortChange: this.onSortChange
    }, options);

    if (sort) {
      tableOptions.sortName = sort.value;
      tableOptions.sortOrder = sort.direction;
    }

    return tableOptions;
  }

  renderContent = () => {
    return (
      <ResponsiveDataList
        {...this.props}
        options={this.tableOptions}
        ref={dataList => { this.dataList = dataList; }}
      />
    );
  }

  render() {
    return (
      <PagedView
        contentType="list"
        {...this.props}
        onPageChange={this.onPageChange}
        loadData={this.loadData}>
        {this.renderContent()}
      </PagedView>
    );
  }
}
